import actionTypes from "../actionTypes";
import moment from "moment";

const initialState = {
  info: {
    customerNumber: "",
    customerName: "",
    startTime: "",
    currentTime: "",
    sessionId: "",
    agentInfo: {},
    agentId: "",
    custInfo: {},
    custId: "",
    monitorState: "",
    slots: [],
  },
  callList: [],
  transcription: [],
  transcriptionUpdate: [],
  agentAssist: [],
  summary: {},
  summaryLoading: false,
  callChecklist: [
    // {
    //   "name": "Greeting & Introduction",
    //   "topics": [
    //     {
    //       "topic": "Answer Promptly",
    //       "checked": true,
    //     },
    //     {
    //       "topic": "Introduce Yourself",
    //       "checked": true,
    //     }
    //   ]
    // },
    // {
    //   "name": "Active Listening & Issue Understanding",
    //   "topics": [
    //     {
    //       "topic": "Listen Attentively",
    //       "checked": false,
    //     }
    //   ]
    // }
  ],
  // summary: {
  //   topic:
  //     "Customer is looking to get the Roadside Assistance Flat Tire Service",
  //   summary:
  //     "The customer, Rahul Pathak, had a flat tire and contacted ASAI Insurance for roadside assistance. He provided his location and vehicle details, and a technician was assigned to assist him. The conversation included the customer's policy number, date of birth, phone numbers, and email address.",
  //   type: "Roadside Assistance",
  //   intent: "Related",
  //   tags: "Roadside Assistance, Flat Tire, ASAI Insurance",
  //   moderation: "No",
  //   tl_nsfw: "No",
  //   confidence_score: "90",
  //   confidence_score_exp:
  //     "The conversation was straightforward and provided all necessary information for the roadside assistance request.",
  //   pii: "Yes",
  //   pii_info:
  //     "Policy number: P020035678904, Date of birth: 1989-03-25, Phone numbers: 2245213388, 12245213388, Email address: JONEVANS407@EMAILNET.COM",
  //   pci: "No",
  //   pci_info: "None",
  //   ai_rating_for_user_question: "5",
  //   ai_rating_exp_for_user_question:
  //     "The customer provided clear and relevant information for the roadside assistance request.",
  //   ai_rating_for_ai_response: "5",
  //   ai_rating_exp_for_ai_response:
  //     "The responses provided were accurate and helpful in resolving the customer's issue.",
  //   sentiment: "Neutral",
  //   language: "English",
  //   is_conversation_complete: "Yes",
  //   is_escalation_necessary: "No",
  //   static__policy_no: "P020035678904",
  //   static__date_of_birth: "1989-03-25",
  //   static__work_phone: "12245213388",
  //   static__home_phone: "2245213388",
  //   static__email: "JONEVANS407@EMAILNET.COM",
  //   static__first_name: "Rahul",
  //   static__last_name: "Pathak",
  //   static__city: "Naperville",
  //   static__country: "USA",
  //   entities:
  //     "Customer Name: Rahul Pathak, Policy Number: P020035678904, Date of Birth: 1989-03-25, Phone Number: 2245213388, Email Address: JONEVANS407@EMAILNET.COM, Vehicle Make: Honda, Vehicle Model: CRV, Vehicle Year: 2020, Vehicle Color: Red, Location: 25 South Commons Drive, Aurora, Illinois 60504, USA",
  // },
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.CALL_INFO: {
      newState.monitorState = "";
      if (
        action.payload &&
        action.payload.data &&
        action.payload.data.data &&
        action.payload.userId
      ) {
        let callData = action.payload.data;
        let userId = action.payload.userId;
        if (callData.transferCall && callData.transferCall == "Transfer") {
          if (callData.transferCallData) {
            newState.info.sessionId = callData.transferCallData.sessionId;
            newState.info.agentId = callData.transferCallData.Id;
            try {
              newState.info.initdate =
                moment(callData.transferCallData.startTime)
                  .utc()
                  .format("DD-MM-YYYY") ||
                moment()
                  .utc()
                  .format("DD-MM-YYYY");
            } catch (error) {
              newState.info.initdate = moment()
                .utc()
                .format("DD-MM-YYYY");
            }
            newState.transferCall = "Transfer";
          }
        } else if (callData.monitorCall && callData.monitorCall == "Monitor") {
          if (callData.monitorCallData) {
            newState.info.sessionId = callData.monitorCallData.sessionId;
            newState.info.agentId = callData.monitorCallData.Id;
            try {
              newState.info.initdate =
                moment(callData.monitorCallData.startTime)
                  .utc()
                  .format("DD-MM-YYYY") ||
                moment()
                  .utc()
                  .format("DD-MM-YYYY");
            } catch (error) {
              newState.info.initdate = moment()
                .utc()
                .format("DD-MM-YYYY");
            }
            newState.monitorState = "Monitor";
          }
        } else {
          // call info for
          let callInfo =
            callData.data.extraData || callData.data.callInfo || {};
          let agentInfo = {};
          if (callInfo.call1 && callInfo.call1.userId == userId) {
            agentInfo = callInfo.call1;
          } else if (callInfo.call2 && callInfo.call2.userId == userId) {
            agentInfo = callInfo.call2;
          } else if (callInfo.calls && callInfo.calls.length) {
            for (let data of callInfo.calls) {
              if (data.userId == userId) {
                agentInfo = data;
                break;
              }
            }
          } else if (callInfo.slots && callInfo.slots.length) {
            agentInfo = callInfo.slots;
          }
          newState.slots = agentInfo;
          newState.info.isTransferInitialed =
            agentInfo.isTransferInitialed || false;
          newState.info.sessionId = agentInfo.sessionId || "";
          newState.info.agentId = agentInfo.Id || "";
          // newState.info.initdate = agentInfo.startTime ? moment( agentInfo.startTime ).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY");
          try {
            newState.info.initdate =
              moment(agentInfo.startTime)
                .utc()
                .format("DD-MM-YYYY") ||
              moment()
                .utc()
                .format("DD-MM-YYYY");
          } catch (error) {
            newState.info.initdate = moment()
              .utc()
              .format("DD-MM-YYYY");
          }
          // get customer
          let customerInfo = {};
          if (callInfo.call1 && callInfo.call1.isCustomer) {
            customerInfo = callInfo.call1;
          } else if (callInfo.call2 && !callInfo.call2.isCustomer) {
            customerInfo = callInfo.call2;
          } else if (callInfo.calls) {
            for (let data of callInfo.calls) {
              if (data.isCustomer) {
                customerInfo = data;
                break;
              }
            }
          }
          newState.info.custId = customerInfo.Id || "";
        }
      }
      return newState;
    }
    case actionTypes.CALL_List:
      newState.callList = action.payload.data;
      return newState;
    case actionTypes.CALL_CUSTOMER_NUMBER:
      newState.customerNumber = action.payload.data;
      return newState;
    case actionTypes.CALL_CUSTOMER_NAME:
      newState.customerName = action.payload.data;
      return newState;
    case actionTypes.CALL_START_TIME:
      newState.startTime = action.payload.data;
      return newState;
    case actionTypes.CALL_CURRENT_TIME:
      newState.currentTime = action.payload.data;
      return newState;
    case actionTypes.TRANSCRIPTION_SET:
      if (Array.isArray(action.payload.data)) {
        newState.transcription = action.payload.data;
      } else {
        newState.transcription = [
          ...newState.transcription,
          action.payload.data,
        ];
      }
      return newState;
    case actionTypes.TRANSCRIPTION_UPDATE:
      if (Array.isArray(action.payload.data)) {
        newState.transcription = action.payload.data;
      } else {
        newState.transcription = [
          ...newState.transcription,
          action.payload.data,
        ];
      }
      // newState.transcription = [...newState.transcription, action.payload.data];
      return newState;
    case actionTypes.CLEAR_TRANSCRIPTION:
      newState.transcription = [];
      return newState;
    case actionTypes.SUMMARY_LOADING_SET:
      newState.summaryLoading = action.payload.data;
      return newState;
    case actionTypes.AGENT_ASSIST:
      newState.agentAssist = [...newState.agentAssist, action.payload.data];
      return newState;
    case actionTypes.CLEAR_AGENT_ASSIST:
      newState.agentAssist = [];
      return newState;
    case actionTypes.UPDATE_TRANSLATE_CALL:
      const { id, translateText } = action.payload;

      // Check if the selected chat exists in the messageList object
      if (newState.transcription) {
        const updatedMessages = newState.transcription.map((message) =>
          message.id === id
            ? {
              ...message,
              content: {
                ...message.content,
                translate: translateText, // Add or update the translate field in content
              },
            }
            : message
        );

        const newStateWithUpdates = {
          ...newState,
          transcription: updatedMessages, // Update transcription directly with updatedMessages
        };

        return newStateWithUpdates;
      } else {
        return newState; // Return the current state if the id or selecedChat does not exist
      }
    case actionTypes.SUMMARY_SET:
      if (action.payload.data) {
        newState.summary = action.payload.data;
      } else {
        newState.summary = {};
      }
      return newState;
    case actionTypes.SUMMARY_CLEAR:
      newState.summary = {};
      return newState;
    case actionTypes.CALL_CHECKLIST:
      if (action.payload.data) {
        newState.callChecklist = action.payload.data;
      } else {
        newState.callChecklist = [];
      }
      return newState;
    case actionTypes.CLEAR_CHECKLIST:
      newState.callChecklist = [];
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/call.reducer.js